import { render, staticRenderFns } from "./ValuBanner.vue?vue&type=template&id=897463a4&scoped=true"
import script from "./ValuBanner.vue?vue&type=script&lang=js"
export * from "./ValuBanner.vue?vue&type=script&lang=js"
import style0 from "./ValuBanner.vue?vue&type=style&index=0&id=897463a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897463a4",
  null
  
)

export default component.exports